import {
  useWSModal,
  useWSSnackbar,
  WSCard,
  WSEmptyState,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import { IPayerResponse } from "@wingspanhq/payments/dist/interfaces";
import type { insuranceCoverageApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSQueryCache } from "@ws-react-query";
import { useEffect } from "react";

import { useQueryInsuranceCoverageMonitor } from "../../../../../query/insuranceCoverageMonitor/queries/useQueryInsuranceCoverageMonitor";
import { REQUIREMENTS_DEPENDENCIES } from "../../../dependencies";

type IPolicyType = insuranceCoverageApiSpec.InsuranceCoverage["policyType"];

type Props = {
  onClose: () => void;
  payer: IPayerResponse;
  policyTypes: IPolicyType[];
  insuranceCoverageMonitorId: string;
};

const ModalMatchingInProgress: React.FC<Props> = props => {
  const { openSnackbar } = useWSSnackbar();

  useQueryInsuranceCoverageMonitor(props.insuranceCoverageMonitorId, {
    enabled: true,
    refetchInterval: response => {
      if (response?.status && response?.status !== "Pending") {
        // TODO: issue with cache cause monitor status is updating synchronously and requirement status is updating asynchronously
        setTimeout(() => {
          WSQueryCache.invalidateQueries(REQUIREMENTS_DEPENDENCIES);
          props.onClose();

          setTimeout(() => {
            WSQueryCache.invalidateQueries(REQUIREMENTS_DEPENDENCIES);
          }, 3000);
        }, 3000);

        return false;
      }

      return 3000;
    }
  });

  useEffect(() => {
    // TODO (v3-migration): no v3 field for shareInsurancePolicyTypes.
    openSnackbar({
      type: "warning",
      duration: 5000,
      message: "Sharing insurance policy types isn't available yet"
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <WSList gap="XL">
      <WSCard header="Policy matching">
        <WSList gap="L">
          <WSList gap="M">
            <WSInfoBox
              icon="loader"
              iconColor="blue400"
              theme="neutral"
              transparent
            >
              Please wait while we check your resources for matching policies...
            </WSInfoBox>

            <WSEmptyState
              bgColor="gray"
              orientation="horizontal"
              size="S"
              title={""}
              type="documents"
            />
            <WSInfoBox
              icon="time"
              iconColor="gray600"
              theme="neutral"
              transparent
            >
              Please wait while we check your resources for matching policies...
            </WSInfoBox>
          </WSList>
          <WSInfoBox theme="neutral">
            Do not close the pop-up while we checking your resources. If you
            close and exit out before any matches are found you can restart the
            process again.
          </WSInfoBox>
        </WSList>
      </WSCard>
    </WSList>
  );
};

export const useModalMatchingInProgress = () =>
  useWSModal(ModalMatchingInProgress, {
    title: "Policy matching",
    size: "M"
  });
